/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentSummaryPolicyDetail {
    getFixupPrototypeFunction() { return ComplianceAssessmentSummaryPolicyDetail.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentSummaryPolicyDetail>): ComplianceAssessmentSummaryPolicyDetail {
        let obj = Object.assign(new ComplianceAssessmentSummaryPolicyDetail(), model);
        ComplianceAssessmentSummaryPolicyDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentSummaryPolicyDetail>): ComplianceAssessmentSummaryPolicyDetail {
        if (!model) return null;
        return ComplianceAssessmentSummaryPolicyDetail.newInstance(<ComplianceAssessmentSummaryPolicyDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentSummaryPolicyDetail) {
        if (!obj) return;

        models.ComplianceAssessmentSummaryPolicyDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentSummaryPolicyDetail): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentSummaryPolicyDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.violated_resource_count === undefined) {
            this.violated_resource_count = 0;
        }
        if (this.evaluated_resource_count === undefined) {
            this.evaluated_resource_count = 0;
        }
    }

    /**
     * Policy ID
     */
    policy_id: string;

    /**
     * Number of violated resources
     */
    violated_resource_count: number;

    /**
     * Number of evaluated resources
     */
    evaluated_resource_count: number;

}
